import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, {
  useCallback,
  useEffect,
} from 'react';
import URL from 'url-parse';

import Loading from 'components/Loading';
import Page from 'containers/Page';
import styles from './index.scss';

const LinkPage = ({ location, node: link, relay, viewer }) => {
  const redirect = useCallback(
    () => {
      if (window) {
        window.location.replace(link.url);
      }
    },
    [link.url],
  );
  useEffect(
    () => {
      const skipClick = get(location, 'state.skipClick');
      if (skipClick) {
        redirect();
      } else {
        // TODO; Link click mutation
        //  TODO: onsuccess or onfailure redirect handling
        redirect();
      }
    },
    [
      link,
      location,
      redirect,
      relay,
    ],
  );
  const url = new URL(link.url);
  const localUrl = new URL(process.env.APP_URL);
  return localUrl.host !== url.host
    ? (
      <Page
        title='Redirecting...'
        viewer={viewer}
      >
        <Loading>
          <div className={styles.message}>
            Redirecting you to <a href={link.url}>{link.url}</a>, one moment...
          </div>
        </Loading>
      </Page>
    )
    : null;
};

LinkPage.propTypes = {
  location: PropTypes.object.isRequired,
  node: PropTypes.object.isRequired,
  relay: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default LinkPage;
